import { render, staticRenderFns } from "./ReportViewTransferencias.vue?vue&type=template&id=ea04e750&scoped=true&"
import script from "./ReportViewTransferencias.vue?vue&type=script&lang=js&"
export * from "./ReportViewTransferencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea04e750",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
  VTooltip,
})
